import { useEffect } from "react";

/** Título de la pestaña del navegador: «Página · Portal de clientes BVL». Lo anuncia el lector al navegar. */
export function useTituloPagina(titulo: string) {
  useEffect(() => {
    document.title = titulo;
  }, [titulo]);
}
